/**
 * @generated SignedSource<<a3ac28e5a9278b276355b87bd34429fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgAdminTeamsScreenQuery$variables = Record<PropertyKey, never>;
export type OrgAdminTeamsScreenQuery$data = {
  readonly organisation: {
    readonly id: string;
    readonly name: string;
    readonly teams: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string;
          readonly " $fragmentSpreads": FragmentRefs<"OrgTeamListItem_team">;
        };
      }>;
    } | null;
  };
};
export type OrgAdminTeamsScreenQuery = {
  response: OrgAdminTeamsScreenQuery$data;
  variables: OrgAdminTeamsScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgAdminTeamsScreenQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Organisation",
          "kind": "LinkedField",
          "name": "organisation",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": (v2/*: any*/),
              "concreteType": "TeamConnection",
              "kind": "LinkedField",
              "name": "teams",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TeamEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Team",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        (v0/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "OrgTeamListItem_team"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "teams(first:1000)"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OrgAdminTeamsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TeamConnection",
            "kind": "LinkedField",
            "name": "teams",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "icon",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "color",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreTopic",
                        "kind": "LinkedField",
                        "name": "topics",
                        "plural": true,
                        "selections": [
                          (v0/*: any*/),
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Store",
                        "kind": "LinkedField",
                        "name": "store",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "includeExternalId",
                                "value": false
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "workspaceBreadcrumbs",
                            "storageKey": "workspaceBreadcrumbs(includeExternalId:false)"
                          },
                          (v0/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "teams(first:1000)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "02e7b311d143d3a82f976c836f5367bf",
    "id": null,
    "metadata": {},
    "name": "OrgAdminTeamsScreenQuery",
    "operationKind": "query",
    "text": "query OrgAdminTeamsScreenQuery {\n  organisation {\n    id\n    name\n    teams(first: 1000) {\n      edges {\n        node {\n          name\n          id\n          ...OrgTeamListItem_team\n        }\n      }\n    }\n  }\n}\n\nfragment AHTeamIcon on Team {\n  icon\n}\n\nfragment OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store on Store {\n  workspaceBreadcrumbs(includeExternalId: false)\n}\n\nfragment OrgTeamListItem_team on Team {\n  name\n  ...AHTeamIcon\n  color\n  topics {\n    id\n    name\n  }\n  store {\n    name\n    ...OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a4b257ca5e935b76fb5e37d4e151f590";

export default node;
